/*
 *
 * BlogPostPage actions
 *
 */

const SCOPE = 'app/BlogPostPage/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,
    RESET_CONTENTS: `${SCOPE}RESET_CONTENTS`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_BLOGS_IS_LOADED: `${SCOPE}SET_BLOGS_IS_LOADED`,
    FETCH_BLOGS: `${SCOPE}FETCH_BLOGS`,
    FETCH_BLOGS_STARTED: `${SCOPE}FETCH_BLOGS_STARTED`,
    FETCH_BLOGS_SUCCESSFULLY: `${SCOPE}FETCH_BLOGS_SUCCESSFULLY`,
    FETCH_BLOGS_FAILED: `${SCOPE}FETCH_BLOGS_FAILED`,
    FETCH_BLOGS_CANCELLED: `${SCOPE}FETCH_BLOGS_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const resetContents = () => ({ type: ActionTypes.RESET_CONTENTS });

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Blogs
 */
export const setBlogsIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_BLOGS_IS_LOADED, isLoaded });
export const fetchBlogs = () => ({ type: ActionTypes.FETCH_BLOGS });
export const fetchBlogsStarted = () => ({ type: ActionTypes.FETCH_BLOGS_STARTED });
export const fetchBlogsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_BLOGS_SUCCESSFULLY,
    res,
});
export const fetchBlogsFailed = (error) => ({
    type: ActionTypes.FETCH_BLOGS_FAILED,
    error,
});
export const fetchBlogsCancelled = () => ({
    type: ActionTypes.FETCH_BLOGS_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});
